import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import LogoP from "../ui/atoms/LogoP";
import TitleZ from "../ui/atoms/TitleZ";
import Buttonz from "../ui/atoms/Buttonz";
import "../styles/main.scss";
import "../styles/compo.scss";
import "../styles/vars.scss";

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    var id = setTimeout(function () {
      document.title = "UUD - Page not found";
    }, 0);
    return function () {
      clearTimeout(id);
    };
  }, []);

  return (
    <Layout>
      <div className="not-found-page not-found-page--in-layout">
        <div className="not-found-page__inner">
          <div className="form-box">
            <LogoP
              logo="logo03"
              hoverLogo="logo03"
              className="not-found-page__logo"
              scale="120px"
              to="/"
            />
          </div>
          <div className="form-box">
            <TitleZ
              title="404"
              // text={
              //   <>
              //    Page Not Found!
              //     </>
              //   }
              />
            </div>

        </div>
      </div>
    </Layout>
  );
}
